export default "__VITE_ASSET__FO49qAwT__"